// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"209":"component---src-templates-dumpsters-kpp-pages-js","684":"cada2cc6","774":"framework"}[chunkId] || chunkId) + "-" + {"209":"39f622039b7b36c0e42e","212":"b36da1161a3b613544ff","589":"e5755b5cf428fee68086","684":"52154eeec5cfe3c2df60","774":"64fb867057913ead4b67"}[chunkId] + ".js";
};